import React from 'react';

interface ErrorMessageProps {
  message?: string;
  show?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, show = true }) => {
  if (!message || !show) {
    return null;
  }

  return (
    <div className="error-message" role="alert" aria-live="polite">
      {message}
    </div>
  );
};

export default ErrorMessage;
